module.exports = __webpack_public_path__ + "static/3-75d7efa52f9d1a969718d2f6dad0be02.jpg";